export default __webpack_public_path__ + "static/media/kvadar.1aa371ce.jpg";